import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import classNames from "classnames";
import NavItem from "./components/NavItem";
import PageItem from "./components/PageItem";

var Pagination = /*#__PURE__*/function (_React$Component) {
  _inherits(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination() {
    var _this;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentPage: _this.props.initialPage
    });

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(Pagination.displayName));

    _defineProperty(_assertThisInitialized(_this), "clientSidePagination", void 0);

    _defineProperty(_assertThisInitialized(_this), "handlePageChange", function (value) {
      var pageCount = _this.props.pageCount;
      var currentPage = _this.state.currentPage;
      var newPage = currentPage + value;

      if (newPage < 1 || newPage > pageCount) {
        return;
      }

      _this.setIndex(newPage);
    });

    _defineProperty(_assertThisInitialized(_this), "setIndex", function (index) {
      var onPageChanged = _this.props.onPageChanged;

      var url = _this.getComputedHref(index);

      if (_this.props.onPageChanged) {
        /**
         * TODO:
         * this `setState` does not actually do anything since `NavItem`
         * is an anchor tag with an `href` by default it will hit the server for the next page
         * this component never will re-render from a state change because of this condition
         */
        _this.setState({
          currentPage: index
        }, function () {
          if (onPageChanged) {
            onPageChanged(index);
          }
        });
      } else {
        window.location.assign(url);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderEllipses", function (id) {
      return /*#__PURE__*/React.createElement(PageItem, {
        key: "".concat(Pagination.displayName, ".PageItemEllipses").concat(id)
      }, "...");
    });

    _defineProperty(_assertThisInitialized(_this), "renderPageItem", function (index) {
      return /*#__PURE__*/React.createElement(PageItem, {
        "data-testid": "pageItem"
        /** TODO: this href will override the onClick making this non-client-friendly,
         * we should decide if we support client functionality assuming this can be used outside of AEM too
         * */
        ,
        href: _this.getComputedHref(index),
        key: "".concat(Pagination.displayName, ".PageItem").concat(index),
        active: _this.state.currentPage === index,
        onClick: function onClick() {
          return _this.setIndex(index);
        }
      }, index);
    });

    _defineProperty(_assertThisInitialized(_this), "renderPageItems", function () {
      var _this$props = _this.props,
          outerBoundPageCount = _this$props.outerBoundPageCount,
          pageCount = _this$props.pageCount,
          pageRangeCount = _this$props.pageRangeCount;
      var currentPage = _this.state.currentPage;
      var items = [];
      var ellipsesCount = 0;

      if (pageCount <= pageRangeCount) {
        /**
         * When the total # of pages does not exceed a given pageRangeCount _n_
         * ex: `<- 1 2 3 4 5 ->`
         */
        items = Array.from(Array(pageCount), function (_, idx) {
          return _this.renderPageItem(idx + 1);
        });
      } else if (currentPage < pageRangeCount) {
        /**
         * For a given pageRangeCount _n_, the current page is in the first _n_ pages
         * ex: `<- 1 2 3 4 5 ... 10 ->`
         */
        items = [].concat(_toConsumableArray(Array.from(Array(pageRangeCount), function (_, idx) {
          return _this.renderPageItem(idx + 1);
        })), [_this.renderEllipses(++ellipsesCount), _this.renderPageItem(pageCount)]);
      } else if (currentPage > pageCount - pageRangeCount) {
        /**
         * For a given pageRangeCount _n_, the current page is in the last _n_ pages
         * ex: `<- 1 ... 10 11 12 ->`
         */
        items = [_this.renderPageItem(1), _this.renderEllipses(++ellipsesCount)].concat(_toConsumableArray(Array.from(Array(pageRangeCount), function (_, idx) {
          return _this.renderPageItem(pageCount - idx);
        }).reverse()));
      } else {
        /**
         * The current page is in the middle of the total number of pages
         * i.e. for a given pageRangeCount _n_ to display, the current page is neither within
         *   the first _n_ items, nor the last _n_ items
         */

        /**
         * lowerBound represents how many pageItems to display smaller than the current page
         * upperBound represents how many pageItems to display larger than the current page
         */
        var lowerBound = Math.floor(pageRangeCount / 2); // eslint-disable-line

        var upperBound = pageRangeCount - lowerBound - 1;
        /**
         * Generate the page items before the first ellipses
         */

        var lowerOuterBoundPageItems = Array.from(Array(outerBoundPageCount), function (_, idx) {
          return _this.renderPageItem(idx + 1);
        });
        /**
         * Generate the page items after the first ellipses, before the current page
         */

        var lowerBoundPageItems = Array.from(Array(lowerBound), function (_, idx) {
          return _this.renderPageItem(currentPage - idx - 1);
        }).reverse();

        var currentItem = _this.renderPageItem(currentPage);
        /**
         * Generate the page items after the current page, before the last ellipses
         */


        var upperBoundPageItems = Array.from(Array(upperBound), function (_, idx) {
          return _this.renderPageItem(currentPage + idx + 1);
        });
        /**
         * Generate the page items after the last ellipses
         */

        var upperOuterBoundPageItems = Array.from(Array(outerBoundPageCount), function (_, idx) {
          return _this.renderPageItem(pageCount - idx);
        }).reverse();
        /**
         * `<-  1 2 3 ... 10 11 *12* 13 14 ... 28 29 30 -> `
         */

        items = [].concat(_toConsumableArray(lowerOuterBoundPageItems), [_this.renderEllipses(++ellipsesCount)], _toConsumableArray(lowerBoundPageItems), [currentItem], _toConsumableArray(upperBoundPageItems), [_this.renderEllipses(++ellipsesCount)], _toConsumableArray(upperOuterBoundPageItems));
      }

      return items;
    });

    _defineProperty(_assertThisInitialized(_this), "getComputedHref", function (index) {
      if (_this.clientSidePagination) {
        return "";
      }

      return _this.props.baseUrl.replace("{currentPage}", index);
    });

    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          borderlessAtStandard = _this$props2.borderlessAtStandard,
          condensed = _this$props2.condensed,
          condensedAtNarrow = _this$props2.condensedAtNarrow,
          displayNavigationButtons = _this$props2.displayNavigationButtons,
          pageCount = _this$props2.pageCount;
      var currentPage = this.state.currentPage;
      return /*#__PURE__*/React.createElement("nav", {
        className: this.getClassName(),
        role: "navigation",
        "aria-label": "Pagination Navigation"
      }, /*#__PURE__*/React.createElement("ul", {
        className: this.getClassName({
          descendantName: "items"
        })
      }, displayNavigationButtons && /*#__PURE__*/React.createElement(NavItem, {
        borderlessAtStandard: borderlessAtStandard,
        ariaLabel: "Previous",
        "data-testid": "navItemLeft",
        key: "NavItemLeft",
        direction: "left"
        /** TODO: this href will override the onClick making this non-client-friendly,
         * we should decide if we support client functionality assuming this can be used outside of AEM too
         */
        ,
        href: this.getComputedHref(currentPage + Pagination.DECREMENT),
        onClick: function onClick() {
          return _this2.handlePageChange(Pagination.DECREMENT);
        },
        disabled: currentPage === 1
      }), condensed ? /*#__PURE__*/React.createElement("li", {
        className: this.getClassName({
          descendantName: "condensed",
          modifiers: classNames({
            condensedAtNarrow: condensedAtNarrow
          })
        }),
        "data-testid": "paginationCondensed"
      }, "".concat(currentPage, " / ").concat(pageCount)) : this.renderPageItems(), displayNavigationButtons && /*#__PURE__*/React.createElement(NavItem, {
        borderlessAtStandard: borderlessAtStandard,
        ariaLabel: "Next",
        "data-testid": "navItemRight",
        key: "NavItemRight",
        direction: "right"
        /** TODO: this href will override the onClick making this non-client-friendly,
         * we should decide if we support client functionality assuming this can be used outside of AEM too
         */
        ,
        href: this.getComputedHref(currentPage + Pagination.INCREMENT),
        onClick: function onClick() {
          return _this2.handlePageChange(Pagination.INCREMENT);
        },
        disabled: currentPage === pageCount
      })));
    }
  }]);

  return Pagination;
}(React.Component);

_defineProperty(Pagination, "displayName", "Pagination");

_defineProperty(Pagination, "defaultProps", {
  baseUrl: "",
  condensedAtNarrow: true,
  displayNavigationButtons: true,
  initialPage: 1,
  outerBoundPageCount: 1,
  pageRangeCount: 5
});

_defineProperty(Pagination, "PageItem", PageItem);

_defineProperty(Pagination, "NavItem", NavItem);

_defineProperty(Pagination, "INCREMENT", 1);

_defineProperty(Pagination, "DECREMENT", -1);

export default Pagination;